// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GroupsSorts_wrapper__UFpq9","list":"GroupsSorts_list__Jyo19","button":"GroupsSorts_button__OPjLs","is_active":"GroupsSorts_is_active__mpOdk"};